export default __webpack_public_path__ + "static/VA logo-db56a3df83d55733f5643b95259655a2.svg";